import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {Button, Col, Flex, Row} from "antd";
import {CloseCircleOutlined, FullscreenOutlined, SaveOutlined} from "@ant-design/icons";
import Note from "@/views/Note/NoteItem/NoteItemIndex";
import NewNote from "@/views/Note/NewNoteIndex";
import "./DialogNote.css"
import {useNavigate} from "react-router-dom";
import {addEventListener} from "@/common/event";
import {EVENT_NOTE_FULLSCREEN_SAVE} from "@/Const";
import {imgPathPerfix} from "@/utils";
let mIsFullDialog = false;

const DialogNote = forwardRef(function _DialogNote(props:{onCloseEvent:any,onFullScreen:any,element:any,isReadonlyMode:boolean},ref){
    useImperativeHandle(ref,()=>({
        setNoteData:setNoteData,
        onSaveEvent:onSaveEvent
    }))
    const nav = useNavigate();
    const newNoteRef = useRef<any>();
    const [titleWidth,setTitleWidth] = useState('540px');
    const [editWidth,setEditWidth] = useState('534px');
    const [isDialogFullScreen,setIsDialogFullScreen] = useState(false);
    const [richEditHeight,setRichEditHeight] = useState('700px')

    /**
     * 设置笔记数据
     * @param element
     */
    const setNoteData = (element)=>{
        newNoteRef.current.setElementData(element)
    }

    useEffect(()=>{
        setNoteData(props.element);

        window.addEventListener("resize",()=>{
            onResize();
        })
    },[])

    //保存
    const onSaveEvent = async (isSave=false,isInsertToCanvas=false)=>{
        let noteData;
        if(isSave){
            noteData = await (newNoteRef.current.getNoteData())
        }
        props.onCloseEvent(isSave,noteData,isInsertToCanvas);
    }
    //全屏
    const onFullScreenEvent = ()=>{
        props.onFullScreen();
        mIsFullDialog = true;
        setIsDialogFullScreen(true)
        newNoteRef.current.setIsFullScreenDialog(true);
        onResize(true);

        // (newNoteRef.current.getNoteData()).then(noteData=>{
        //     nav("/editNote", {state:{isFullScreen:true,newNoteData:noteData}});
        // })
    }

    const onResize = (isUpdate=false)=>{
        if(mIsFullDialog || isUpdate){
            const nWidth = document.body.clientWidth;
            const nHeight = document.body.clientHeight;
            setTitleWidth((nWidth)+'px');
            setRichEditHeight((nHeight - 20)+'px')
            setEditWidth((nWidth)+'px');
        }
        if (isDialogFullScreen){

        }
    }
    return(
        <Flex vertical style={{position:'relative',height:'100%',width:'100%',zIndex:'11'}}>
            <Flex gap={"middle"} style={{alignItems:'center',backgroundColor:'#efefef',height:'46px',position:'fixed',top:'0px',
                display:isDialogFullScreen?'none':'inherit', width:'100%',padding:'0 16px',zIndex:'999'}}>
                {/*<CloseCircleOutlined onClick={()=>props.onCloseEvent(false)} className='title-icon'/>*/}
                <img src={imgPathPerfix()+"full_screen.png"} onClick={onFullScreenEvent} className='title-icon img-medium-small cursor-pointer'/>
                <span style={{flexGrow:'1'}}/>
                {/*<SaveOutlined onClick={onSaveEvent} className='title-icon'/>*/}
                <Button style={{padding:'0px 2px',visibility:props.isReadonlyMode?'hidden':'visible',display:'none'}}
                        type={"text"} onClick={()=>onSaveEvent(true,false)}>Save</Button>
                <Button style={{padding:'0px 2px',visibility:props.isReadonlyMode?'hidden':'visible'}}
                        type={"text"} onClick={()=>onSaveEvent(true,true)}>Add to page</Button>
            </Flex>
            <div style={{height:'100%',
                marginTop:isDialogFullScreen?'0px':'0px',
                zIndex:'11',
                width:isDialogFullScreen?'100%':'100%'}}>
                <NewNote ref={newNoteRef} onBackCallback={(isSave=false)=>onSaveEvent(isSave)} isReadonlyMode={props.isReadonlyMode}/>
            </div>

        </Flex>
    )
});

export default DialogNote;





















